// 登录
export const loginRule = {
  userAcount: [{
    required: true,
    message: '请输入用户名',
    trigger: 'blur'
  }],
  userPwd: [{
    required: true,
    message: '请输入密码',
    trigger: 'blur'
  }]
}
export const supplierLoginRule = {
  loginCode: [{
    required: true,
    message: '请输入登录账号',
    trigger: 'blur'
  }],
  loginPwd: [{
    required: true,
    message: '请输入密码',
    trigger: 'blur'
  }]
}

// 存货
export const inventoryRule = {
  skuName: [{
    required: true,
    message: '请输入存货名称',
    trigger: 'blur'
  }],
  classCode: [{
    required: true,
    message: '请选择存货分类',
    trigger: 'blur'
  }],
  skuSpec: [{
    required: true,
    message: '请输入规格',
    trigger: 'blur'
  }],
  offerPrice: [{
    required: true,
    message: '请输入供价',
    trigger: 'blur'
  }],
  retailPrice: [{
    required: true,
    message: '请输入零售价',
    trigger: 'blur'
  }],
  remark: [{
    required: false,
    message: '请输入备注',
    trigger: 'blur'
  }]
}

// 产品系列
export const classesRule = {
  className: [{
    required: true,
    message: '请输入产品名称',
    trigger: 'blur'
  }]
}

// 区域管理
export const areaRule = {
  areaName: [{
    required: true,
    message: '请输入区域名称',
    trigger: 'blur'
  }],
  areaCode:[
    {
      required: true,
      message: '请输入区域编码',
      trigger: 'blur'
    }
  ]
}

// 部门管理
export const departRule = {
  dptName: [{
    required: true,
    message: '请输入部门名称',
    trigger: 'blur'
  }]
}

// 账户管理
export const accountRule = {
  userAcount: [{
    required: true,
    message: '请输入登录账号',
    trigger: 'blur'
  }],
  limit: [{
    required: true,
    message: '请选择数据权限',
    trigger: 'change'
  }],
  userName: [{
    required: true,
    message: '请输入用户名',
    trigger: 'blur'
  }],
  userPwd: [{
    required: true,
    message: '请输入登录密码',
    trigger: 'blur'
  }],
  roleCode: [{
    required: true,
    message: '请选择角色',
    trigger: 'submit'
  }],
  dptCode: [{
    required: true,
    message: '请选择部门',
    trigger: 'submit'
  }],
  areaCode: [{
    required: true,
    message: '请选择区域',
    trigger: 'submit'
  }],
  phone: [{
    required: true,
    message: '请输入手机号',
    trigger: 'blur'
  }, {
    type: 'string',
    pattern: /^1[\d\s]{10}$/,
    message: '请输入合法手机号',
    trigger: 'blur'
  }],
  email: [{
    required: false,
    message: '请输入邮箱',
    trigger: 'blur'
  }],
  travelStandard: [{
    required: true,
    message: '请输入出差标准/日',
    trigger: 'blur'
  }],
  phoneFeeStandard: [{
    required: true,
    message: '请输入 手机费补贴标准/月',
    trigger: 'blur'
  }],
}


// 客户存货
export const supermarketRule = {
  cusName: [{
    required: true,
    message: '请选择经销商',
    trigger: 'submit'
  }],
  superCode: [{
    required: true,
    message: '请选择超市',
    trigger: 'submit'
  }],
  skuCode: [{
    required: true,
    message: '请选择存货',
    trigger: 'submit'
  }],
  offerPrice: [{
    required: true,
    message: '请输入供价',
    trigger: 'blur'
  }],
  retailPrice: [{
    required: true,
    message: '请输入零售价',
    trigger: 'blur'
  }],
  remark: [{
    required: false,
    message: '请输入备注',
    trigger: 'blur'
  }]
}


// 角色管理
export const roleRule = {
  roleName: [{
    required: true,
    message: '请输入角色名',
    trigger: 'blur'
  }],
  // dptCode: [{
  //   required: true,
  //   message: '请选择部门',
  //   trigger: 'blur'
  // }],
  menuCodes: [{
    required: true,
    message: '请选择角色权限',
    trigger: 'submit'
  }],
  roleStatus: [{
    required: false,
    message: '请选择',
    trigger: 'submit'
  }],
  remark: [{
    required: false,
    message: '请输入备注',
    trigger: 'blur'
  }]
}

// 客户管理
export const clientRule = {
  cusName: [{
    required: true,
    message: '请输入客户名称',
    trigger: 'blur'
  }],
  areaCode: [{
    required: true,
    message: '请选择区域',
    trigger: 'submit'
  }],
  dptCode: [{
    required: true,
    message: '请选择部门',
    trigger: 'submit'
  }],
  salesName: [{
    required: true,
    message: '请输入业务员',
    trigger: 'blur'
  }],
  remark: [{
    required: false,
    message: '请输入备注',
    trigger: 'blur'
  }]
}

// 超市管理
export const marketRule = {
  cusName: [{
    required: true,
    message: '请选择客户',
    trigger: 'blur'
  }],
  superName: [{
    required: true,
    message: '请输入超市名称',
    trigger: 'blur'
  }],
  addr: [{
    required: false,
    message: '请输入地址',
    trigger: 'blur'
  }],
  remark: [{
    required: false,
    message: '请输入备注',
    trigger: 'blur'
  }]
}

// 门店管理
export const storeRule = {
  cusName: [{
    required: false,
    message: '请选择客户',
    trigger: 'submit'
  }],
  superCode: [{
    required: true,
    message: '请选择超市',
    trigger: 'submit'
  }],
  menName: [{
    required: true,
    message: '请输入门店名称',
    trigger: 'blur'
  }],
  addr: [{
    required: false,
    message: '请输入详细地址',
    trigger: 'blur'
  }],
  remark: [{
    required: false,
    message: '请输入备注',
    trigger: 'blur'
  }]
}

// 审批流管理
export const processesRule = {
  menuCode: [{
    required: true,
    message: '请选择模块',
    trigger: 'submit'
  }],
}

// 进场申请
export const applicationRules = {
  cusName: [{
    required: true,
    message: '请选择客户',
    trigger: 'change'
  }],
  areaName: [{
    required: true,
    message: '销售区域不能为空',
    trigger: 'submit'
  }],
  superName: [{
    required: true,
    message: '请选择超市',
    trigger: 'change'
  }],
  applyMensName: [{
    required: false,
    message: '请选择门店',
    trigger: 'submit'
  }],
  inNature: [{
    required: true,
    message: '请选择进场性质',
    trigger: 'change'
  }],
  superApplySkus: [{
    required: true,
    type: 'array',
    message: '请添加条码',
    trigger: 'submit'
  }],
  dptCode: [{
    required: true,
    message: '部门不能为空',
    trigger: 'submit'
  }],
  userCode: [{
    required: true,
    message: '销售员不能为空',
    trigger: 'submit'
  }]
}

// 促销申请
export const salesAppliRules = {
  cusName: [{
    required: true,
    message: '请选择客户',
    trigger: 'change'
  }],
  areaName: [{
    required: true,
    message: '销售区域不能为空',
    trigger: 'submit'
  }],
  superName: [{
    required: true,
    message: '请选择超市',
    trigger: 'change'
  }],
  salesMensName: [{
    required: true,
    message: '请选择门店',
    trigger: 'change'
  }],
  movieNum: [{
    required: true,
    message: '档期不能为空',
    trigger: 'change'
  }],
  salesSkus: [{
    required: false,
    type: 'array',
    message: '请添加条码',
    trigger: 'submit'
  }],
  salesSkuClasses: [{
    required: true,
    type: 'array',
    message: '请添加产品系列',
    trigger: 'submit'
  }],
  dptCode: [{
    required: true,
    message: '部门不能为空',
    trigger: 'submit'
  }],
  userCode: [{
    required: true,
    message: '销售员不能为空',
    trigger: 'submit'
  }],
  applyAmount: [{
    required: true,
    message: '申请金额不能为空',
    trigger: 'submit'
  }],
  tjzrAmount: [{
    required: false,
    message: '折让金额不能为空',
    trigger: 'submit'
  }],
}
// 促销申请
export const salesAppliRules2 = {
    cusName: [{
        required: true,
        message: '请选择客户',
        trigger: 'change'
    }],
    areaName: [{
        required: true,
        message: '销售区域不能为空',
        trigger: 'submit'
    }],
    superName: [{
        required: true,
        message: '请选择超市',
        trigger: 'change'
    }],
    salesMensName: [{
        required: false,
        message: '请选择门店',
        trigger: 'change'
    }],
    movieNum: [{
        required: true,
        message: '档期不能为空',
        trigger: 'change'
    }],
    salesSkus: [{
        required: false,
        type: 'array',
        message: '请添加条码',
        trigger: 'submit'
    }],
    salesSkuClasses: [{
        required: true,
        type: 'array',
        message: '请添加产品系列',
        trigger: 'submit'
    }],
    dptCode: [{
        required: true,
        message: '部门不能为空',
        trigger: 'submit'
    }],
    userCode: [{
        required: true,
        message: '销售员不能为空',
        trigger: 'submit'
    }],
    applyAmount: [{
        required: true,
        message: '申请金额不能为空',
        trigger: 'submit'
    }],
    tjzrAmount: [{
        required: false,
        message: '折让金额不能为空',
        trigger: 'submit'
    }],
}

// 差旅费报销
export const applyRules = {
  department: [{
    required: true,
    message: '部（股）不能为空',
    trigger: 'submit'
  }],
  businessTraveller: [{
    required: true,
    message: '出差人不能为空',
    trigger: 'submit'
  }],
  // date: [{
  //   required: true,
  //   type: "date",
  //   message: '请选择起讫时间',
  //   trigger: 'submit'
  // }],
  travelDays: [{
    required: true,
    message: '请填写出差天数',
    trigger: 'blur'
  }]
}
